export enum MapDoodleEnum {
    PIN = 'pin',
    POLYLINE = 'polyline',
    POLYGON = 'polygon',
    Close = 'off',
    CIRCLE = 'circle',
    CLEAR = 'clear',
    SAVE = 'save',
    MULTIPOLYGON = 'multipolygon',
    CLIP = 'clip',
    CLIPOK = 'clip-ok',
    BOUNDARY = 'boundary',
    BOUNDARYOK = 'boundary-ok',
    VOLUME = 'volume',
    GRID = 'grid',
}
